import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconMessageCircle(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m6.497 12.498.217-.215.303.047c.324.05.652.076.983.076 3.029 0 5.455-2.077 5.455-4.6S11.03 3.207 8 3.207 2.545 5.284 2.545 7.806c0 1.423.777 2.759 2.116 3.635l.358.234-.102.414a4.105 4.105 0 0 1-.643 1.371c.857-.021 1.593-.34 2.223-.962zM1.333 7.806C1.333 4.574 4.338 2 8 2s6.667 2.573 6.667 5.806S11.662 13.612 8 13.612c-.293 0-.584-.017-.873-.05-.989.866-2.198 1.228-3.562 1.068a.9.9 0 0 1-.58-1.487c.285-.325.493-.647.628-.964-1.437-1.092-2.28-2.675-2.28-4.373z"
  }));
}
IconMessageCircle.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconMessageCircle.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconMessageCircle as default };
